import { render, staticRenderFns } from "./PowerInfo.vue?vue&type=template&id=4fe6e356&scoped=true&"
import script from "./PowerInfo.vue?vue&type=script&lang=ts&"
export * from "./PowerInfo.vue?vue&type=script&lang=ts&"
import style0 from "./PowerInfo.vue?vue&type=style&index=0&id=4fe6e356&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe6e356",
  null
  
)

export default component.exports